import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
    parseSemaphoreValue,
    SEMAPHORE_KEYS,
    SEMAPHORE_SCALE_LABEL_KEYS,
    semaphoreCounts,
    semaphoreItemHasContent,
    SemaphoreStatus,
} from '../../semaphore-options';

/**
 * Semáforo só para LEITURA: lixeira, favoritos e a prévia antiga. Desenha como o PDF
 * (`items/semaphore.css`): resumo sempre no topo e a lista (com a descrição embaixo do
 * item quando há), pulando itens vazios. Palavra da escala em branco cai na tradução
 * padrão, como no PDF.
 */
@Component({
    selector: 'semaphore-view',
    templateUrl: 'semaphore-view.component.html',
    styleUrl: 'semaphore-view.component.scss',
    imports: [],
})
export class SemaphoreViewComponent {
    /** `value` cru do item (`{ scale, items }`). */
    public value = input<unknown>();
    /** Mostra no máximo estes itens (lixeira e favoritos); o resto vira "+N". */
    public maxItems = input<number | null>(null);

    private _translate = inject(TranslateService);

    public readonly keys = SEMAPHORE_KEYS;
    public parsed = computed(() => parseSemaphoreValue(this.value()));
    public printable = computed(() => this.parsed().items.filter(semaphoreItemHasContent));
    public visible = computed(() => {
        const max = this.maxItems();
        return max ? this.printable().slice(0, max) : this.printable();
    });
    public hidden = computed(() => this.printable().length - this.visible().length);
    public stats = computed(() => semaphoreCounts(this.parsed().items));

    public labelOf(key: SemaphoreStatus): string {
        const label = this.parsed()
            .scale.find(s => s.key === key)
            ?.label.trim();
        return label || this._translate.instant(SEMAPHORE_SCALE_LABEL_KEYS[key]);
    }
}
